function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Input, Form, Button, Select, Alert, Divider, Radio, Switch, Modal, Descriptions, message, DatePicker } from 'antd';
import { Container, Row, Col } from "react-bootstrap";
import axios from 'axios';
import Common from "../includes/Common";
import { ExclamationCircleFill } from 'react-bootstrap-icons';
import Receipt from "../Receipt";
import moment from "moment";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var confirm = Modal.confirm;
var Option = Select.Option;
var EditCandidate = function EditCandidate(_ref) {
  var _ref$handleUpdate = _ref.handleUpdate,
    handleUpdate = _ref$handleUpdate === void 0 ? null : _ref$handleUpdate,
    candidate = _ref.candidate;
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFormLoading = _useState2[0],
    setIsFormLoading = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    errorMessage = _useState4[0],
    setErrorMessage = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    successMessage = _useState6[0],
    setSuccessMessage = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    createdValues = _useState8[0],
    setCreatedValues = _useState8[1];
  var _useState9 = useState([]),
    _useState0 = _slicedToArray(_useState9, 2),
    companyOptions = _useState0[0],
    setCompanyOptions = _useState0[1];
  var _useState1 = useState([]),
    _useState10 = _slicedToArray(_useState1, 2),
    companies = _useState10[0],
    setCompanies = _useState10[1];
  var _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    deptOptions = _useState12[0],
    setDeptOptions = _useState12[1];
  var _useState13 = useState([]),
    _useState14 = _slicedToArray(_useState13, 2),
    serviceOptions = _useState14[0],
    setServiceOptions = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    deptDisabled = _useState16[0],
    setDeptDisabled = _useState16[1];
  var _useState17 = useState(true),
    _useState18 = _slicedToArray(_useState17, 2),
    companyDisabled = _useState18[0],
    setCompanyDisabled = _useState18[1];
  var _useState19 = useState(true),
    _useState20 = _slicedToArray(_useState19, 2),
    serviceDisabled = _useState20[0],
    setServiceDisabled = _useState20[1];
  var _useState21 = useState([]),
    _useState22 = _slicedToArray(_useState21, 2),
    serviceTree = _useState22[0],
    setServiceTree = _useState22[1];
  var _useState23 = useState(true),
    _useState24 = _slicedToArray(_useState23, 2),
    insDisabled = _useState24[0],
    setInsDisabled = _useState24[1];
  var _useState25 = useState(false),
    _useState26 = _slicedToArray(_useState25, 2),
    isPdaActive = _useState26[0],
    setIsPdaActive = _useState26[1];
  var _useState27 = useState(0),
    _useState28 = _slicedToArray(_useState27, 2),
    totalAmount = _useState28[0],
    setTotalAmount = _useState28[1];
  var _useState29 = useState(null),
    _useState30 = _slicedToArray(_useState29, 2),
    userCompany = _useState30[0],
    setUserCompany = _useState30[1];
  var today = new Date();
  var date = today.getDate() + '/' + (today.getMonth() + 1) + '/' + today.getFullYear();
  var genderOptions = [{
    label: 'Homme',
    value: 'H'
  }, {
    label: 'Femme',
    value: 'F'
  }];
  var categoryOptions = [{
    label: 'Particulier',
    value: 0
  }, {
    label: 'Conventionné',
    value: 1
  }];
  var onCategorieChanged = function onCategorieChanged(e) {
    if (e == 1) {
      form.setFieldsValue({
        insurance_company_id: companyOptions
      });
      setCompanyDisabled(false);
      setInsDisabled(false);
    } else {
      setCompanyDisabled(true);
      setInsDisabled(true);
    }
  };
  var onDeptChanged = function onDeptChanged(e) {
    setServiceOptions([]);
    var optArray = e.toString().split(",");
    optArray.forEach(function (o) {
      var ar = serviceTree.filter(function (services) {
        return services.id == o;
      });
      if (ar.length > 0) {
        ar.forEach(function (d) {
          if (d.services.length > 0) {
            d.services.forEach(function (s) {
              s.medical_items.forEach(function (e) {
                setServiceOptions(function (prev) {
                  return [].concat(_toConsumableArray(prev), [{
                    label: e.label,
                    value: e.id
                  }]);
                });
              });
            });
            form.setFieldsValue({
              service_id: serviceOptions
            });
            setServiceDisabled(false);
          }
        });
      }
    });
  };
  var onCompanyChanged = function onCompanyChanged(v) {
    setUserCompany(companies.filter(function (c) {
      return c.id == v;
    })[0]);
  };
  function printR() {
    var content = document.getElementById("prtdiv");
    var pri = document.getElementById("ifmcontentstoprint").contentWindow;
    pri.document.open();
    pri.document.write(content.innerHTML);
    pri.document.close();
    pri.focus();
    pri.print();
  }
  var execOrder = function execOrder(formData) {
    setIsFormLoading(true);
    axios.post(Common.baseApiUrl + 'editcustomer', formData).then(function (response) {
      setIsFormLoading(false);
      if (response.data.status == 200) {
        form.resetFields();
        setSuccessMessage(response.data.message);
        handleUpdate();
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
        //printR();  
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setIsFormLoading(false);
      setErrorMessage('Une erreur est survenue');
    });
  };
  var onFinish = function onFinish(values) {
    var formData = new FormData();
    formData.append("id", candidate.id.toString());
    formData.append('name', values.name);
    formData.append('gender', values.gender);
    formData.append('birthdate', values.birthdate);
    formData.append("category", values.category);
    formData.append("sub_category", values.sub_category);
    formData.append('nationality', values.nationality);
    formData.append('company_id', values.company_id);
    formData.append('matricule', values.matricule);
    formData.append('job', values.job);
    formData.append("link", values.link);
    formData.append('reason', values.reason);
    formData.append('address', values.address);
    formData.append('mobile_first', values.mobile_first);
    formData.append('mobile_second', values.mobile_second);
    formData.append('idnumber', values.idnumber);
    formData.append('idnumber_expire_date', values.idnumber_expire_date);
    formData.append('email', values.email);
    formData.append("candidate_code", values.candidate_code);
    formData.append('sos_person_name', values.sos_person_name);
    formData.append('sos_person_mobile', values.sos_person_mobile);
    formData.append('sos_person_email', values.sos_person_email);
    formData.append("user_id", Common.currentUser.id);
    setErrorMessage('');
    setSuccessMessage('');
    confirm({
      title: 'Confirmez-vous ?',
      icon: /*#__PURE__*/_jsx(ExclamationCircleFill, {}),
      content: /*#__PURE__*/_jsxs("p", {
        children: ["La cr\xE9ation du patient ", values.name]
      }),
      onOk: function onOk() {
        execOrder(formData);
      },
      onCancel: function onCancel() {
        console.log('Cancel');
      }
    });
  };
  useEffect(function () {
    form.setFieldsValue({
      name: candidate.name,
      gender: candidate.gender,
      nationality: candidate.nationality,
      company_id: candidate.company_id,
      job: candidate.job,
      reason: candidate.reason,
      sub_category: candidate.sub_category,
      category: candidate.category,
      address: candidate.address,
      link: candidate.link,
      email: candidate.email,
      mobile_first: candidate.mobile_first,
      matricule: candidate.matricule,
      sos_person_name: candidate.sos_person_name,
      sos_person_mobile: candidate.sos_person_mobile,
      sos_person_email: candidate.sos_person_email,
      idnumber_expire_date: candidate.idnumber_expire_date,
      birthdate: moment(candidate.birthdate)
    });
    var cr = axios.get(Common.baseApiUrl + "getcompanylist");
    var st = axios.get(Common.baseApiUrl + "getservicetree");
    axios.all([cr, st]).then(function (response) {
      var crResponse = response[0];
      var stResponse = response[1];
      if (crResponse.data.status == 200) {
        setCompanies(crResponse.data.companyList);
        crResponse.data.companyList.forEach(function (c) {
          setCompanyOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              label: c.label,
              value: c.id
            }]);
          });
        });
        form.setFieldsValue({
          insurance_company_id: companyOptions
        });
      }
      if (stResponse.data.status == 200) {
        setServiceTree(stResponse.data.services);
        stResponse.data.services.forEach(function (d) {
          setDeptOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              value: d.id,
              label: d.label
            }]);
          });
        });
        form.setFieldsValue({
          department: deptOptions
        });
        form.setFieldsValue({
          gender: 'F',
          category: 0,
          insnumber: null
        });
      }
    })["catch"](function (error) {});
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [errorMessage.length != 0 && /*#__PURE__*/_jsx(Alert, {
      message: errorMessage,
      type: "error",
      showIcon: true
    }), successMessage.length != 0 && /*#__PURE__*/_jsx(Alert, {
      message: successMessage,
      type: "success",
      showIcon: true
    }), /*#__PURE__*/_jsx("br", {}), createdValues != null && /*#__PURE__*/_jsxs("div", {
      style: {
        textAlign: 'center'
      },
      id: "prtdiv",
      children: [/*#__PURE__*/_jsx("div", {
        style: {
          width: '70px'
        },
        children: /*#__PURE__*/_jsx("img", {
          src: "drawables/emgl.png",
          style: {
            width: '100%'
          }
        })
      }), /*#__PURE__*/_jsxs("h2", {
        children: ["RNC : ", createdValues.rnc]
      }), /*#__PURE__*/_jsxs(Descriptions, {
        column: 1,
        children: [/*#__PURE__*/_jsx(Descriptions.Item, {
          label: "T\xE9l\xE9phone : ",
          children: createdValues.mobile
        }), /*#__PURE__*/_jsx(Descriptions.Item, {
          label: "Nom :",
          children: createdValues.firstname + ' ' + createdValues.lastname
        }), /*#__PURE__*/_jsx(Descriptions.Item, {
          label: "Montant : ",
          children: "200 000 GNF"
        }), /*#__PURE__*/_jsx(Descriptions.Item, {
          label: "M. Paiement : ",
          children: createdValues.paymentmethod
        })]
      }), /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx("b", {
          children: "Adresse: Conakry, Kip\xE9, Prima center. Tel: 611 72 49 21"
        })
      })]
    }), /*#__PURE__*/_jsx("iframe", {
      id: "ifmcontentstoprint",
      style: {
        height: '0px',
        width: '0px',
        position: 'absolute'
      }
    }), /*#__PURE__*/_jsxs(Form, {
      layout: "vertical",
      onFinish: onFinish,
      form: form,
      children: [/*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 7,
          md: 7,
          sm: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            label: "Matricule",
            name: "matricule",
            rules: [{
              required: true,
              message: "Ce champ est obligatoire"
            }],
            children: /*#__PURE__*/_jsx(Input, {
              placeholder: "Numero Matricule"
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 5,
          md: 5,
          sm: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            label: "Cat\xE9gorie",
            name: "category",
            rules: [{
              required: true,
              message: "Ce champ est obligatoire"
            }],
            children: /*#__PURE__*/_jsx(Select, {
              placeholder: "Choisir une cat\xE9gorie",
              options: [{
                label: "Aucune",
                value: 0
              }, {
                label: "A1",
                value: "A1"
              }, {
                label: "A2",
                value: "A2"
              }, {
                label: "B1",
                value: "B1"
              }, {
                label: "B2",
                value: "B2"
              }, {
                label: "B3",
                value: "B3"
              }, {
                label: "B4",
                value: "B4"
              }, {
                label: "B5",
                value: "B5"
              }]
            })
          })
        })]
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 4,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "name",
            label: "Nom complet",
            rules: [{
              required: true,
              message: 'Ce champs est obligatoire'
            }],
            children: /*#__PURE__*/_jsx(Input, {})
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 4,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "birthdate",
            label: "Date de naissance",
            rules: [{
              required: true,
              message: 'Ce champs est obligatoire'
            }],
            children: /*#__PURE__*/_jsx(DatePicker, {
              format: "DD/MM/YYYY"
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 4,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "nationality",
            label: "Nationalit\xE9",
            rules: [{
              required: true,
              message: 'Ce champs est obligatoire'
            }],
            children: /*#__PURE__*/_jsx(Input, {})
          })
        })]
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 4,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "job",
            label: "Emploi/Poste",
            rules: [{
              required: true,
              message: 'Ce champs est obligatoire'
            }],
            children: /*#__PURE__*/_jsx(Input, {})
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 4,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "company_id",
            label: "Entreprise",
            rules: [{
              required: true,
              message: 'Ce champs est obligatoire'
            }],
            children: /*#__PURE__*/_jsx(Select, {
              onChange: onCompanyChanged,
              defaultActiveFirstOption: true,
              showSearch: true,
              options: companyOptions
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 4,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "reason",
            label: "Motif",
            rules: [{
              required: true,
              message: 'Ce champs est obligatoire'
            }],
            children: /*#__PURE__*/_jsx(Select, {
              options: [{
                label: "VISITE ANNUELLE",
                value: 0
              }, {
                label: "PRE-EMBAUCHE",
                value: 1
              }, {
                label: "PERMIS DE TRAVAIL",
                value: 2
              }, {
                label: "JOURNALIER",
                value: 3
              }]
            })
          })
        })]
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 4,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "address",
            label: "Adresse complete",
            rules: [{
              required: true,
              message: 'Ce champs est obligatoire'
            }],
            children: /*#__PURE__*/_jsx(Input, {})
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 4,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "mobile_first",
            label: "T\xE9l\xE9phone Mobile",
            rules: [{
              required: true,
              message: 'Ce champs est obligatoire'
            }],
            children: /*#__PURE__*/_jsx(Input, {})
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 4,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "mobile_second",
            label: "T\xE9l\xE9phone mobile residentiel",
            children: /*#__PURE__*/_jsx(Input, {})
          })
        })]
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 4,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "idnumber",
            label: "Num. Passeport",
            children: /*#__PURE__*/_jsx(Input, {})
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 4,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "id_number_expire_date",
            label: "Date d'expiration Passeport",
            children: /*#__PURE__*/_jsx(DatePicker, {})
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 4,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "email",
            label: "E-mail",
            children: /*#__PURE__*/_jsx(Input, {})
          })
        })]
      }), /*#__PURE__*/_jsx(Divider, {
        children: /*#__PURE__*/_jsx("b", {
          children: "Personne \xE0 contacter"
        })
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 4,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "sos_person_name",
            label: "Nom",
            rules: [{
              required: true,
              message: 'Ce champs est obligatoire'
            }],
            children: /*#__PURE__*/_jsx(Input, {})
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 4,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "sos_person_mobile",
            label: "Contact",
            rules: [{
              required: true,
              message: 'Ce champs est obligatoire'
            }],
            children: /*#__PURE__*/_jsx(Input, {})
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 4,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "sos_person_email",
            label: "E-mail",
            children: /*#__PURE__*/_jsx(Input, {})
          })
        })]
      }), /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "link",
            label: "Lien externe (Optionnel)",
            children: /*#__PURE__*/_jsx(Input, {
              placeholder: "Entrer le lien ici"
            })
          })
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "submit",
        children: /*#__PURE__*/_jsx(Button, {
          loading: isFormLoading,
          htmlType: "submit",
          type: "primary",
          children: /*#__PURE__*/_jsx("b", {
            children: "ENREGISTRER"
          })
        })
      })]
    })]
  });
};
export default EditCandidate;